import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {NEWS} from "../news-widget.consts";
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {NewsWidgetDisplayEvent} from "../models/news-widget.display.event";

export class NewsWidgetDisplayHandler extends AnalyticsEventHandler {
  type = NEWS.ACTION_TYPES.displayHandler;

  static injectables = [...AnalyticsEventHandler.injectables];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = NewsWidgetDisplayEvent;
  }
}
